import { render, staticRenderFns } from "./RulesNotApplicable.vue?vue&type=template&id=26d8f083&scoped=true"
import script from "./RulesNotApplicable.vue?vue&type=script&lang=js"
export * from "./RulesNotApplicable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d8f083",
  null
  
)

export default component.exports